import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/templates/tasks/$taskId/")({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
